import { render, staticRenderFns } from "./copy-dialog.vue?vue&type=template&id=b43b8d1a&scoped=true&"
import script from "./copy-dialog.vue?vue&type=script&lang=js&"
export * from "./copy-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43b8d1a",
  null
  
)

export default component.exports